import { DataModel, IDataModel, getTableNameFull, getConfig, HttpModel } from './data.model';
import { IProdutos } from '../models/produtos.model';
import { TextSearch } from '../comum/textSearch';
import { Subject } from 'rxjs';
import { Http, Headers } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';



export interface ICarrinho extends IDataModel {
    pedido: string;
    fechado: boolean,
}
export interface ICarrinhoItem {
    fornecedor: number,
    produto: string,
    nome: string,
    unidade: string,
    estado: number,
    qtde: number,
    precoVenda: number,
    valor: number,
    freteBase: number,  // referencia para calculo
    frete?: number,  // valor cobrado
}
export interface ICarrinhoPagamento {
    nome?: string,
    operacao?: string,
    parcelas?: number,
    maxParcelas?: number,
}

export interface ICarrinhoTotais {
    freteTotal?: number,
}

export class CarrinhoModel extends DataModel<ICarrinho>
{
    stCarrinho = getTableNameFull('carrinho');
    dadosPedido: any;
    pedido: any;
    uid: string;
    baixado: boolean = false;
    data: Date = null;
    entrega: any = {};
    items: ICarrinhoItem[] = [];
    fornecedores = [];
    subTotal: number = 0;
    fretePedido: number = 0;
    freteTotal: number = 0;
    total: number = 0;
    totais: ICarrinhoTotais = {};
    formaPagamento: ICarrinhoPagamento = {}
    eventChange: Subject<any> = new Subject();
    clear() {
        this.items = [];
        this.entrega = {};
        this.somar();
        this.salvar();
        this.pedido = this.dbConn.createId();
        this.uid = null;
    }


    constructor(private db: AngularFirestore, private http: Http) {
        super(db, 'carrinho');
    }

    AtribuirFornecedor(fornAttrib) {
        if (!fornAttrib) return;
        let b = { fornecedor: fornAttrib.codigo, freteMinimo: fornAttrib.freteMinimo },
            achou = false;
        if (!this.fornecedores)
            this.fornecedores = [];
        this.fornecedores.forEach(element => {
            if (element.fornecedor == b.fornecedor) {
                achou = true;
                element.freteMinimo = b.freteMinimo;
            }
        });
        if (!achou) {
            this.fornecedores.push(b);
        }
    }
    somarFornecedor(item) {
        this.fornecedores.forEach(element => {
            if (element.fornecedor == item.fornecedor) {
                element.valor += item.valor;
            }
        });
    }
    somarFreteMinimo() {
        let rt = 0;
        this.fornecedores.forEach(element => {
            rt += (element.freteMinimo ? element.freteMinimo : 0);
        });
        return rt;
    }
    somar() {
        var old = this.total;
        this.fornecedores.forEach(element => {
            element.total = 0;
        });
        this.total = 0;
        this.totais.freteTotal = 0;
        this.items.forEach(element => {
            element.valor = Math.round(element.qtde * element.precoVenda * 100) / 100;
            this.total += (element.valor);
            this.somarFornecedor(element);
            this.totais.freteTotal += (element.frete ? element.frete : 0);
        });
        this.subTotal = this.total;
        this.fretePedido = this.somarFreteMinimo();
        this.freteTotal = this.totais.freteTotal + this.fretePedido;
        //console.log(this.subTotal,this.freteTotal);
        this.total = this.subTotal + this.freteTotal;
        if (!this.uid) this.uid = this.dbConn.createId()
        if (old != this.total)
            this.eventChange.next(this);
        return this.total;
    }

    salvar() {
        this.data = new Date();
        //console.log(this.toJson());
        window.localStorage.setItem(this.stCarrinho, this.toJson());
        window.localStorage.setItem(getTableNameFull('DataCarrinho'), this.data.toISOString());

    }
    restore() {
        let x = window.localStorage.getItem(this.stCarrinho);

        if (x == null) {
            this.clear();
        } else
            this.fromJson(x);

        this.data = new Date(window.localStorage.getItem(getTableNameFull('DataCarrinho')));

        if (this.data != null) {
            // checar se a data é mais de 24 horas;
            var time = new Date().getTime() - this.data.getTime();
            var dias = time / (24 * 3600 * 1000);
            if (dias > 7) {

                this.clear();
            }
        }

    }

    assign(x: any) {
        this.pedido = x.pedido;
        this.data = x.data;
        this.baixado = x.baixado;
        this.entrega = x.entrega;
        this.items = x.items;
        this.subTotal = x.subTotal;
        this.freteTotal = x.freteTotal;
        this.total = x.total;
        this.formaPagamento = x.formaPagamento;
    }
    values() {
        return {
            pedido: this.pedido,
            data: this.data,
            baixado: this.baixado,
            entrega: this.entrega,
            items: this.items,
            total: this.total,
            formaPagamento: this.formaPagamento,
            subTotal: this.subTotal,
            freteTotal: this.freteTotal,
            totais: this.totais,
        };
    }

    toJson() {
        return JSON.stringify(this.values());
    }
    fromJson(x) {
        let j = JSON.parse(x);
        this.assign(j);
    }

    confirmarPedido(proc) {
        // enviar dados para o servidor;
        if (this.items.length > 0) {
            this.somar();
            this.dadosPedido = this.values();
            this.dadosPedido.search = TextSearch.decode(this.dadosPedido.entrega.nome);
            this.dadosPedido.searchEnder = TextSearch.decode(this.dadosPedido.entrega.ender);
            this.dadosPedido.fechado = false;
            let ordem = 1;
            this.dadosPedido.items.forEach(element => {
                if (element.nome == null)
                    element.nome = '????';
                if (element.unidade == null)
                    element.unidade = '??';
                element.ordem = ordem++;
                element.estado = 0;
                element.fornecedor_estado = element.fornecedor + '.' + element.estado;
            });
            this.dadosPedido.id = this.uid;
            //console.log('Enviando: ',this.dadosPedido);
            //alert(this.dadosPedido);
            new HttpModel(this.http).post ('/carrinho/', this.dadosPedido ).toPromise().then(resp => {
                //console.log('--------------');
                let rsp = JSON.parse(resp._body);
                //console.log(resp);
                this.dadosPedido.pedido = rsp.numero;
                this.dadosPedido.id = rsp.pedidoId;
                this.dadosPedido.data = rsp.data;
                //console.log('--------------');
                if (proc != null) {
                    proc(this.dadosPedido);
                }
                this.clear();
            }).catch(err=>{
               //
               console.log('erro: '+err.message);
            });
        }

        /*  this.getNewID('numero_pedido', r => {
              this.pedido = r.valor;
              this.dadosPedido = this.values();
              this.dadosPedido.search = TextSearch.decode(this.dadosPedido.entrega.nome);
              this.dadosPedido.searchEnder = TextSearch.decode(this.dadosPedido.entrega.ender);
              this.dadosPedido.fechado = false;
              let ordem = 1;
              this.dadosPedido.items.forEach(element => {
                  if (element.nome == null)
                      element.nome = '????';
                  if (element.unidade == null)
                      element.unidade = '??';
                  element.ordem = ordem++;
                  element.estado = 0;
                  element.fornecedor_estado = element.fornecedor + '.' + element.estado;
              });
              this.dadosPedido.id = this.uid;
             // console.log('updateOrInsert');
              this.updateOrInsert(this.uid,this.dadosPedido,
                  ret => {
                      //console.log(ret);
                      this.dadosPedido.items.forEach(element => {
                          this.dbConn.collection(getTableNameFull("carrinhoItems"))
                              .add({
                                  entrega: this.dadosPedido.entrega,
                                  usuario: this.dadosPedido.usuario,
                                  data: this.dadosPedido.data,
                                  pedido: this.dadosPedido.pedido,
                                  pedidoId: this.dadosPedido.id,
                                  ...element
                              });
                      });
                      if (proc != null){
                          proc(this.dadosPedido);
                      }
                      this.clear();
                  })
          })*/
    }



addItem(fornec: number, produto: string, qtde: number, preco: number, item: IProdutos, fornAttrib ?) {
    let achou: boolean = false;
    var v = Math.round(qtde * preco * 100) / 100;
    this.items.forEach(element => {
        if ((element.fornecedor == fornec) && (element.produto == produto)) {
            element.qtde += qtde;
            achou = true;
        }
    });

    if (!achou)
        this.items.push(
            {
                fornecedor: Number(fornec),
                produto: produto,
                nome: item.nome,
                estado: 0,
                unidade: item.unidade,
                qtde: Number(qtde),
                precoVenda: Number(preco),
                valor: v,
                freteBase: 0, // valor referencia
                frete: 0, // valor a cobrar
            });

    this.AtribuirFornecedor(fornAttrib);
    this.somar();
    this.salvar();
}
getCount() {
    return this.items.length;
}

deleteItem(idx) {
    this.items.splice(idx, 1);
    this.somar();
    this.salvar();
}



}
